import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useBranchesUIContext } from "../BranchesUIContext";

const prepareFilter = (queryParams, values) => {
  const { name } = values;
  const newQueryParams = { ...queryParams };
  const filter = { name };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function BranchesFilter() {
  // Branches UI Context
  const branchesUIContext = useBranchesUIContext();
  const branchesUIProps = useMemo(() => {
    return {
      setQueryParams: branchesUIContext.setQueryParams,
      queryParams: branchesUIContext.queryParams,
    };
  }, [branchesUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(branchesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, branchesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      branchesUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        name: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}